<template>
  <div>
    <div class="px-9">
      <v-row>
        <v-col cols="6" sm="4" md="3" lg="2">
          <v-select
              :items="sortable"
              item-value="value"
              item-text="text"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="sortDesc"
              hide-details
              :label="$t('components:dashboard-paginated.sort')"
          />
        </v-col>
        <v-col cols="6" sm="4" md="3" lg="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="options.itemsPerPage"
              :items="elementsPerPage"
              hide-details
              :label="$t('components:common.elements-per-page')"
          />
        </v-col>

        <!-- TODO uncomment if filtering is enabled -->
        <!-- <v-col cols="6" class="d-sm-none">
          <v-select
              :items="dummyFilter"
              :menu-props="{ bottom: true, offsetY: true }"
              hide-details
              label="Filtern nach"
          />
        </v-col> -->

        <v-col class="d-none d-lg-block"></v-col>

        <v-col sm="8" md="6" lg="4">
          <v-text-field
              v-if="!disableSearch"
              v-model="search"
              append-icon="search"
              :value="computedSearch"
              :label="$t('components:common.search')"
              single-line
              hide-details
              clearable
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col v-if="cardView">
          <v-row>
            <v-col cols="12" md="6" lg="5" xl="4" v-for="(item, i) in data" :key="i">
              <ItemCard
                  :item="item"
                  :title="item.name"
                  :subtitle="getAddress(item)"
                  :subtitle2="getObjectNumber(item)"
                  :subtitle3="item.typeName ? item.typeName : ''"
                  :actionBtn1Text="itemCardBtn1Text"
                  :actionBtn2Text="itemCardBtn2Text"
                  :actionBtn3Text="itemCardBtn3Text"
                  :hideActionBtn1="itemCardHideBtn1"
                  :hideActionBtn2="itemCardHideBtn2"
                  :hideActionBtn3="itemCardHideBtn3"
                  :actionBtn1Tooltip="itemCardBtn1Tooltip"
                  :actionBtn2Tooltip="itemCardBtn2Tooltip"
                  :actionBtn3Tooltip="itemCardBtn3Tooltip"
                  :viewBtnTooltip="itemCardViewIconTooltip"
                  @viewItem="viewElement(item)"
                  @cardAction1="cardAction1(item)"
                  @cardAction2="cardAction2(item)"
                  @cardAction3="cardAction3(item)"
                  :bitmapPath="isBuilding ? getFullPath(item.imagePath) : null"
                  :left-corner-icon-source="!isBuilding ? item.typeIconUrl : null"
              />
            </v-col>
          </v-row>
        </v-col>

        <!-- Filter tiles -->
        <!-- TODO uncomment when filtering is implemented and edit above v-col to match grid-->
        <!-- <v-col sm="4" md="3" lg="2" class="text-center filter d-none d-sm-block">
          <v-btn
              v-for="(item, i) in dummyFilter"
              :key="i"
              class="mt-3 mx-auto px-5 py-8 greyBold--text"
              tile
              elevation="0"
              min-width="215"
          >
            <v-icon left>apartment</v-icon>
            {{ item }} <span class="green-dot ml-2"></span>
          </v-btn>
        </v-col> -->
      </v-row>

    </div>
    <div class="px-9"  v-if="data && data.length > 0">
      <v-pagination
          v-model="options.page"
          :length="totalPages"
          :total-visible="7"
      ></v-pagination>
    </div>

   <h5 v-else-if="data && data.length == 0" class="greyTint--text mb-0 mt-5 text-center">{{ $t('common:no-data-found') }}</h5>

  </div>
</template>
<script>
import Utils from "@/modules/core/services/utils";

import ItemCard from '@/modules/core/components/ItemCard'

export default {
  name: 'DashboardPaginated',
  components: {
    ItemCard
  },
  props: {
    cachedSearch: String, // chached Search String from prev Search
    disableSearch: Boolean, // Boolean to disable and hide search

    itemCardHideChart: Boolean, // to hide item card chart,

    itemCardBtn1Text: String, // text for first aciton button
    itemCardBtn2Text: String, // ^ for second
    itemCardBtn3Text: String, // ^ for third

    itemCardHideBtn1: Boolean, // to hide first action button
    itemCardHideBtn2: Boolean, // ^ for second
    itemCardHideBtn3: Boolean, // ^ for third

    itemCardBtn1Tooltip: String, // Text for first action btn tooltip
    itemCardBtn2Tooltip: String, // ^ for second
    itemCardBtn3Tooltip: String, // ^ for third
    itemCardViewIconTooltip: String, // Text for view icon tooltip

    isBuilding: Boolean, // if table contains data of building or facility
  },
  data() {
    return {
      search: '',
      options: {
        sortBy: ['name'],
        sortDesc: [false],
        itemsPerPage: 10,
        page: 1
      },
      data: [],
      totalPages: null,
      searchTimer: null,
      elementsPerPage: [
        {text: '5', value: 5},
        {text: '10', value: 10},
        {text: '15', value: 15},
        {text: this.$t('common:all'), value: -1}
      ],

      sortable: [
        {text: this.$t('components:dashboard-paginated.sort-asc'), value: false},
        {text: this.$t('components:dashboard-paginated.sort-desc'), value: true}
      ],

      sortDesc: false,
      cardView: true
    }
  },
  computed: {


    computedSearch: {
      get() {
        if (this.search) {
          this.$emit('cacheCommit', this.search);
          return this.search
        }
        this.$emit('cacheCommit', null);
        return null
      },
      set(value) {
        this.search = value;
      }
    },

    currentLang() {
      return this.$store.state.translation.language;
    },
  },
  mounted() {

    if(this.cachedSearch) {
      this.search = this.cachedSearch;
    }
    if(this.sortBy) {
      this.options.sortBy[0] = this.sortBy;
    }
    if(this.sortDesc != this.options.sortDesc[0]) {
      this.options.sortDesc[0] = this.sortDesc;
    }
  },
  watch: {
    search() {
      this.computedSearch = this.search
      //use timer function to wait for user to finish until we search
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.options.page = 1; //reset the page back to 1 on search, otherwise we can land on an empty page
        this.callDashboardUpdate();
      }, 500);
    },
    //by deep watching the table options, we can automatically call an update whenever sort/page changes
    options: {
      handler() {
        this.callDashboardUpdate();
      },
      deep: true,
      immediate: true //with this it will trigger on initialization -> we don't have to load on mount
    },
    sortDesc() {
      this.options.sortDesc[0] = this.sortDesc;
      this.callDashboardUpdate();
    },

    currentLang() {
      Utils.sleep(500).then(() =>{
        this.sortable[0].text = this.$t('components:dashboard-paginated.sort-asc');
        this.sortable[1].text = this.$t('components:dashboard-paginated.sort-desc');
        this.elementsPerPage[3].text = this.$t('common:all')
      })
    }
  },
  methods: {
    getAddress(item) {
      // if object is of type building
      if('address_street' in item) {
        return item.address_street + ', ' + item.address_zip + ', ' + item.address_city
        // if object is of type facility
      } else if('buildingStreet' in item) {
        return item.buildingStreet + ', ' + item.buildingZip + ', ' + item.buildingCity
      } else {
        return ''
      }
    },

    getFullPath(filePath) {
      if (filePath)
        return process.env.VUE_APP_ROOT_HOST + filePath;
      return filePath;
    },

    getObjectNumber(item) {
      let objectNumberString = "";
      if (this.isBuilding) {
        objectNumberString = this.$t('common:object-number') + ": ";
      } else {
        objectNumberString = this.$t('common:facility-number') + ": ";
      }

      return objectNumberString + item.objectNumber;
    },

    callDashboardUpdate() {
      clearTimeout(this.tableUpdateTimer);
      this.tableUpdateTimer = setTimeout( () => {
        this.$emit('updateData', this.options, this.search);
      },50);
    },
    fillDashboard(data) {
      if (data == null) {
        this.data = [];
      } else {
        this.data = data.content;
      }
      this.totalPages = data.totalPages
    },
    viewElement(data) {
      this.$emit('viewElement', data);
    },
    cardAction1(item) {
      this.$emit('cardAction1', item);
    },
    cardAction2(item) {
      this.$emit('cardAction2', item);
    },
    cardAction3(item) {
      this.$emit('cardAction3', item);
    }
  }
}
</script>